<div class="row" style="height: 100%;">
  <div class="col" style="height: 100%;">
    <div class="drive-container" style="height: 100%;">
      <iframe class="drive-frame" src="https://hypweb.net/elFinder-nightly/demo/develop/?full=1#elf_ga_Lw" title="Drive"></iframe>
    </div>
  </div>
</div>
